import { Controller, useFormContext } from 'react-hook-form'

import { FF2, PageSection, PageSectionFace, TextareaInput, Validators } from 'ui/components'
import { Col2x } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Narrative = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <PageSection face={PageSectionFace.THIRD} title="Step 5. Narrative" anchor="step5">
      <Col2x>
        <div style={{ paddingTop: 20 }}>
          <Controller
            name="narrative"
            control={control}
            rules={{ validate: Validators.required.field }}
            render={({ field }) => (
              <FF2
                required
                field={field}
                input={(props) => <TextareaInput {...props} data-qa="Narrative" rows={25} maxLength={20000} />}
              />
            )}
          />
        </div>
      </Col2x>
    </PageSection>
  )
}
